import { studentBookingClient } from 'src/api/client';

import { UserEndpoints } from './constants';
import { GetUserExistsSuccessResponse } from './types';

export const getUserExists = async (email: string) => {
    const { data: response } = await studentBookingClient.get<GetUserExistsSuccessResponse>(
        UserEndpoints.getUserExists.replace('{email}', email)
    );

    return response.data;
};
